function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
import { RliPreHook } from '@rocketlane/rli-internal-sdk';
import { stringify } from 'utils/query-string';
import { HttpClient } from 'api/http-client';
import { ExpenseEvents } from 'events/expenses';
import { fieldAccessMetaToBase3 } from 'utils/field-access';
const BASE_URL = '/expenses';
class ExpenseApiClient extends HttpClient {
    async createExpense(expense) {
        return this.post(BASE_URL, expense);
    }
    async updateExpense(expenseId, expense) {
        return this.put(`${BASE_URL}/${expenseId}`, expense);
    }
    async deleteExpense(expenseId) {
        return this.delete(`${BASE_URL}/${expenseId}`);
    }
    constructor(...args){
        super(...args), _define_property(this, "getExpenseById", async (expenseId)=>{
            const response = await this.get(`${BASE_URL}/${expenseId}`);
            return {
                ...response,
                fieldsAccessMetaInBase3: response.fieldsAccessMeta ? fieldAccessMetaToBase3(response.fieldsAccessMeta) : undefined
            };
        }), _define_property(this, "getExpensesByIds", (expenseIds)=>{
            return this.get(`${BASE_URL}/by-ids?expenseIds=${expenseIds}`);
        }), _define_property(this, "extractExpenseDetails", (expenseDocuments)=>{
            return this.post(`${BASE_URL}/extract`, expenseDocuments);
        }), _define_property(this, "updateUserStatusForExpense", (expenseId, entityToApprovalMappingId, entityToApprovalMapping)=>{
            return this.put(`${BASE_URL}/${expenseId}/approvals/${entityToApprovalMappingId}`, entityToApprovalMapping);
        }), _define_property(this, "overrideExpenseStatus", (expenseId, approvalWorkflowLevelId, entityToApprovalMapping)=>{
            return this.put(`${BASE_URL}/${expenseId}/approvals/level/${approvalWorkflowLevelId}/update-status`, entityToApprovalMapping);
        }), _define_property(this, "forceApprovalOnExpense", (expenseId, entityToApprovalMapping)=>{
            return this.put(`${BASE_URL}/${expenseId}/force-approval`, entityToApprovalMapping);
        }), _define_property(this, "getExpenseAuditLogs", (expenseId)=>{
            return this.get(`${BASE_URL}/${expenseId}/audit-logs`);
        }), _define_property(this, "getAccessibleProjects", (action)=>{
            return this.get(`${BASE_URL}/project-access?action=${action}`);
        }), _define_property(this, "getAccessibleUsers", (action, projectId)=>{
            return this.get(`${BASE_URL}/user-access?action=${action}${projectId ? `&projectId=${projectId}` : ''}`);
        }), _define_property(this, "getExpenseAccess", (projectId, userId)=>{
            return this.get(`${BASE_URL}/access?${stringify({
                projectId,
                userId
            }, {
                skipNull: true
            })}`).then((access)=>{
                return {
                    ...access,
                    fieldAccessMetaInBase3: fieldAccessMetaToBase3(access.fieldsAccessMeta)
                };
            });
        }), _define_property(this, "getExpenseAccessFlagsOrder", ()=>{
            return this.get(`${BASE_URL}/access-flags`);
        }), _define_property(this, "getExpenseInheritableFieldsInfo", async (projectIds, taskIds, userIds)=>{
            return this.get(`${BASE_URL}/inheritable-field-values?${stringify({
                projectIds: Array.from(projectIds).join(','),
                taskIds: Array.from(taskIds).join(','),
                userIds: Array.from(userIds).join(',')
            }, {
                skipNull: true,
                skipEmptyString: false
            })}`);
        });
    }
}
_ts_decorate([
    RliPreHook({
        event: ExpenseEvents.ExpenseCreate,
        dataGetter: (expense)=>({
                expense
            })
    })
], ExpenseApiClient.prototype, "createExpense", null);
_ts_decorate([
    RliPreHook({
        event: ExpenseEvents.ExpenseUpdate,
        dataGetter: (expenseId, expense)=>({
                expenseId,
                expense
            })
    })
], ExpenseApiClient.prototype, "updateExpense", null);
_ts_decorate([
    RliPreHook({
        event: ExpenseEvents.ExpenseDelete,
        dataGetter: (expenseId)=>({
                expenseId
            })
    })
], ExpenseApiClient.prototype, "deleteExpense", null);
export const ExpenseApi = new ExpenseApiClient();
